import React, { Dispatch, FC, SetStateAction } from "react";
import { IAulasChamada } from "@deltasge/marauders-map";
import {
  Badge,
  Checkbox,
  IconButton,
  TableCell,
  TableRow as TableRowMUI,
  Tooltip,
} from "@mui/material";
import {
  PlaylistCheck as TarefaIcon,
  Pencil as EditIcon,
  CalendarAlert as DiaSemAulaIcon,
  CalendarCheck as DiaAulaIcon,
  AccountMultipleCheck as ChamadaIcon,
  Plus as AddIcon,
} from "mdi-material-ui";
import { format } from "date-fns";
import { history } from "configs";

export const TableRowAula: FC<{
  aula: IAulasChamada;
  materia: boolean;
  handleEdit: (aula: IAulasChamada) => void;
  selecionados: IAulasChamada[];
  showCheckbox?: boolean;
  setSelecionados: Dispatch<SetStateAction<IAulasChamada[]>>;
  handleGerarAula: (aula: IAulasChamada) => Promise<void>;
}> = ({
  aula,
  handleEdit,
  materia,
  selecionados,
  setSelecionados,
  showCheckbox = false,
  handleGerarAula,
}) => {
  const diaNormal =
    selecionados.length == 0
      ? undefined
      : selecionados.filter((f) => f.diaSemAula != true).length > 0;

  const checked =
    selecionados.find(
      (f) =>
        (f.idDiaAulas == aula.idDiaAulas && f.idDiaAulas != undefined) ||
        (f.idTurma == aula.idTurma &&
          f.idMateria == aula.idMateria &&
          f.data == aula.data &&
          f.aula == aula.aula)
    ) != undefined;

  return (
    <TableRowMUI>
      {showCheckbox && (
        <TableCell>
          <Checkbox
            disabled={
              diaNormal == undefined
                ? false
                : (diaNormal && aula.diaSemAula == true) ||
                  (!diaNormal && aula.diaSemAula != true)
            }
            checked={checked}
            onChange={() => {
              if (!checked) setSelecionados((prev) => [...prev, aula]);
              else
                setSelecionados((prev) => {
                  const notSelected = prev.filter((f) => {
                    return (
                      (f.idDiaAulas != aula.idDiaAulas &&
                        f.idDiaAulas != undefined) ||
                      f.idTurma != aula.idTurma ||
                      f.idMateria != aula.idMateria ||
                      f.data != aula.data ||
                      f.aula != aula.aula
                    );
                  });
                  return notSelected;
                });
            }}
          />
        </TableCell>
      )}
      <TableCell>
        <Tooltip
          title={
            !aula.idDiaAulas
              ? "Aula ainda não registrada (clique para criar)"
              : "Alterar dia de aula"
          }
        >
          <IconButton
            onClick={() => handleGerarAula(aula)}
            color={
              aula.idDiaAulas == undefined
                ? "error"
                : aula.diaSemAula
                ? "inherit"
                : aula.naGrade
                ? "success"
                : "warning"
            }
          >
            <Badge
              badgeContent={aula.isRecuperacao ? "R" : undefined}
              color="secondary"
            >
              <ChamadaIcon />
            </Badge>
          </IconButton>
        </Tooltip>
      </TableCell>
      <TableCell align="right">
        {aula.data ? format(new Date(aula.data), "dd/MM/yyyy") : ""}
      </TableCell>
      <TableCell>{aula.aulaDescricao}</TableCell>
      <TableCell align="right">{aula.horaIni}</TableCell>
      {!materia && <TableCell>{aula.materiaNome?.rUpper()}</TableCell>}
      <TableCell>
        <Tooltip
          title={`${
            aula.idDiaAulas ? "Editar a descrição do " : "Criar registro do "
          }${aula.diaSemAula ? "dia sem aula" : "dia de aula"}`}
        >
          <IconButton size="small" onClick={() => handleEdit(aula)}>
            {aula.idDiaAulas && <EditIcon fontSize="small" />}
            {!aula.idDiaAulas && <AddIcon fontSize="small" color="error" />}
          </IconButton>
        </Tooltip>

        {aula.descricaoChamada}
      </TableCell>
      <TableCell sx={{ width: ({ spacing }) => spacing(1) }}>
        {aula.diaSemAula && (
          <Tooltip title="Dia sem Aula">
            <DiaSemAulaIcon sx={{ verticalAlign: "middle" }} color="action" />
          </Tooltip>
        )}
        {!aula.diaSemAula && (
          <Tooltip title="Dia de aula normal">
            <DiaAulaIcon sx={{ verticalAlign: "middle" }} color="action" />
          </Tooltip>
        )}
      </TableCell>
      <TableCell align="right">
        <Tooltip
          title={!aula.idMensagem ? "Sem tarefa de casa" : "Tarefa de casa"}
        >
          <span>
            <IconButton
              disabled={!aula.idMensagem}
              color={!aula.idMensagem ? undefined : "primary"}
              size="small"
              onClick={() =>
                history.push(`/publicacoes/detalhes/${aula.idMensagem}/tab/1`)
              }
            >
              <TarefaIcon />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRowMUI>
  );
};
